import React, { useState, useEffect, useContext } from 'react';
import { Route, Routes, Navigate } from "react-router-dom";
import { RoutesCustom } from "../routes";
import { AuthContext } from '../utils/AuthContext';
import { RouteComponents } from '../routesMapping';
//Public Pages
import Signin from "./examples/Signin";
import NotFound from './examples/NotFound';
import Preloader from "../components/Preloader";
import SidebarAdmin from '../components/admin/Sidebar';
import SidebarClient from '../components/client/Sidebar';
import ResetPassword from './examples/ResetPassword';
import Navbar from "../components/Navbar";
import { Outlet } from "react-router-dom";
export const RouteWithLoader = () => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader show={!loaded} />
      {loaded && <Outlet />}
    </>
  );
};


export const RouteWithSidebar = () => {
  const [loaded, setLoaded] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { role } = useContext(AuthContext);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const SidebarComponent = role === "client" ? SidebarClient : role === "admin" ? SidebarAdmin : SidebarClient;

  return (
    <>
      <Preloader show={!loaded} />
      {loaded && (
        <div className={`dashboard-layout ${isSidebarOpen ? "sidebar-open" : "sidebar-collapsed"}`}>
          <SidebarComponent isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
          <main className="content">
            <Navbar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
            <Outlet />
          </main>
        </div>
      )}
    </>
  );
};




export default function HomePage() {
  const { role } = useContext(AuthContext);

  return (
    <Routes>
      {/* Public routes with loader */}
      <Route element={<RouteWithLoader />}>
        <Route path={RoutesCustom.Signin.url} element={<Signin />} />
        <Route path={RoutesCustom.NotFound.url} element={<NotFound />} />
        
       <Route  path={RoutesCustom.ResetPassword.url} element={<ResetPassword />} />
       
      </Route>

      {/* Private / Dashboard routes with sidebar */}
      <Route element={<RouteWithSidebar />}>
        {Object.entries(RouteComponents).map(([url, Component]) => {
          // Admin-only routes
          if (role === 'admin' && url.startsWith('/admin')) return <Route key={url} path={url} element={<Component />} />;
          // Client-only routes
          if ((role === 'client' || role === 'specialClient') && url.startsWith('/client')) return <Route key={url} path={url} element={<Component />} />;
         
          return null;
        })}
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to={RoutesCustom.NotFound.url} replace />} />
    </Routes>
  );
}


